<app-selector
  class="quarter"
  [items]="quarterItems"
  (changeValue)="onQuarterChange($event)"
>
</app-selector>
<app-selector
  class="type"
  [items]="mapModeItems"
  [multilabel]="!!false"
  [value]="selectedMapMode ? selectedMapMode.value : null"
  (changeValue)="onMapModeChange($event)"
>
</app-selector>
